import { Music, ArrowRight, MessageSquare } from 'lucide-react';
import { useApp } from '../lib/AppContext';
import Header from '../components/Header';

export default function ContributeRoot() {
  const { navigateTo } = useApp();

  return (
    <div className="min-h-screen bg-[#111111]" style={{ paddingBottom: 'calc(92px + env(safe-area-inset-bottom, 0px) + 16px)' }}>
      <Header mode="title" title="Contribute" />

      <div className="w-full mx-auto px-6 py-6 lg:px-8 lg:py-8">
        <div className="max-w-5xl mx-auto">
          <div className="mb-6 text-center">
            <p className="text-[15px] text-gray-300 leading-relaxed max-w-2xl mx-auto">
              Every song and idea helps grow a meaningful civicbeat library.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-7 mb-6 max-w-6xl mx-auto">
            <button
              onClick={() => navigateTo('submit-song')}
              className="bg-[#1A1A1A] rounded-2xl p-6 lg:p-7 border hover:bg-[#1C1C1C] transition-all text-left group max-w-sm lg:max-w-[840px] w-full mx-auto lg:mx-0 flex flex-col h-full"
              style={{ borderColor: 'rgba(255, 255, 255, 0.08)', boxShadow: '0px 12px 28px 3px rgba(0, 0, 0, 0.52), 0px 2px 8px 1px rgba(0, 0, 0, 0.16), inset 0px 1px 1px rgba(255, 255, 255, 0.04), inset 0px -1px 2px rgba(0, 0, 0, 0.22)' }}
            >
              <div className="flex items-center gap-[18px] mb-3">
                <div className="flex items-center justify-center w-[52px] h-[52px] rounded-full bg-[#40E0D0]/10 flex-shrink-0">
                  <Music className="w-6 h-6 text-[#40E0D0]" strokeWidth={2} />
                </div>
                <h3 className="text-xl font-bold text-white leading-[1.3]">
                  Submit a Song
                </h3>
              </div>
              <p className="text-sm text-gray-300 leading-relaxed mb-4">
                Share a song with a story or moment behind it. We'll explore its civic meaning and may feature it.
              </p>
              <div className="flex items-center gap-2 text-[#40E0D0] font-semibold text-sm group-hover:gap-3 transition-all mt-auto">
                Submit a Song →
              </div>
            </button>

            <button
              onClick={() => navigateTo('feedback')}
              className="bg-[#1A1A1A] rounded-2xl p-6 lg:p-7 border hover:bg-[#1C1C1C] transition-all text-left group max-w-sm lg:max-w-[840px] w-full mx-auto lg:mx-0 flex flex-col h-full"
              style={{ borderColor: 'rgba(255, 255, 255, 0.08)', boxShadow: '0px 12px 28px 3px rgba(0, 0, 0, 0.52), 0px 2px 8px 1px rgba(0, 0, 0, 0.16), inset 0px 1px 1px rgba(255, 255, 255, 0.04), inset 0px -1px 2px rgba(0, 0, 0, 0.22)' }}
            >
              <div className="flex items-center gap-[18px] mb-3">
                <div className="flex items-center justify-center w-[52px] h-[52px] rounded-full bg-[#40E0D0]/10 flex-shrink-0">
                  <MessageSquare className="w-6 h-6 text-[#40E0D0]" strokeWidth={2} />
                </div>
                <h3 className="text-xl font-bold text-white leading-[1.3]">
                  Share Feedback
                </h3>
              </div>
              <p className="text-sm text-gray-300 leading-relaxed mb-4">
                Tell us what's useful, confusing, or what you'd love to see. Your input directly shapes how civicbeat evolves.
              </p>
              <div className="flex items-center gap-2 text-[#40E0D0] font-semibold text-sm group-hover:gap-3 transition-all mt-auto">
                Give Feedback →
              </div>
            </button>
          </div>

          <p className="text-sm text-gray-500 text-center leading-relaxed">
            Thank you for helping build civicbeat.
          </p>
        </div>
      </div>
    </div>
  );
}
